import thunkMiddleware from "redux-thunk";
import { configureStore, AnyAction, ThunkDispatch } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import reducer, { RootState } from "./Slices";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"],
  blackList: ["app"],
};

const persistedReducer = persistReducer(persistConfig, reducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunkMiddleware],
});

export const persistor = persistStore(store);

// Update the AppDispatch type to handle thunk actions
export type AppDispatch = ThunkDispatch<RootState, unknown, AnyAction>;

// Use throughout the site instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;